import { useEffect, useState } from "react";
import { toast } from "sonner";
import { g, pa } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function DolciPesce() {
  const [rows, setRows] = useState([]);
  const [vals, setVals] = useState({});

  const load = async () => {
    const r = await g("/availability");
    setRows(r);
    setVals(Object.fromEntries(r.map((x) => [x.id, x.qty_total])));
  };
  useEffect(() => {
    load();
  }, []);

  const save = async (m) => {
    await pa(`/menu/${m.id}/qty`, { qty_total: Number(vals[m.id]) || 0 });
    toast.success(`${m.name}: disponibilità caricata`);
    load();
  };

  return (
    <div className="fade-up space-y-5" data-testid="dolci-pesce-page">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">Pannello titolare</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">Dolci e pesce</h1>
        <p className="mt-1 text-sm text-slate-500">
          Carico manuale delle disponibilità del giorno. Si scaricano automaticamente all'invio delle comande.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {rows.map((m) => (
          <Card key={m.id} className="p-5" data-testid={`avail-${m.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-semibold">{m.name}</p>
                <p className="text-xs text-slate-500">{m.category} · {m.department}</p>
              </div>
              <span
                className={`font-num rounded-full px-2.5 py-1 text-xs font-bold ${
                  m.qty_left <= 0 ? "bg-slate-200 text-slate-600" : m.qty_left < 3 ? "bg-rose-100 text-rose-700" : "bg-emerald-100 text-emerald-700"
                }`}
              >
                {m.qty_left <= 0 ? "Finito" : `Restano ${m.qty_left}`}
              </span>
            </div>
            <div className="mt-4 flex gap-2">
              <Input
                type="number"
                min="0"
                className="h-10"
                value={vals[m.id] ?? 0}
                onChange={(e) => setVals({ ...vals, [m.id]: e.target.value })}
                data-testid={`avail-input-${m.id}`}
              />
              <Button onClick={() => save(m)} data-testid={`avail-save-${m.id}`}>
                Carica
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
